function Close() {
  let panelContainer = document.getElementById('panel-container');
  if (panelContainer.hasChildNodes()) {
    panelContainer.removeChild(panelContainer.lastChild);
  }
}


export default Close;
